<template>
  <div>
    <BulkActivateUserModal
      v-if="value.showBulkActivateUserModal"
      :showBulkModal="value.showBulkActivateUserModal"
      @cancel="closeModal($options.showBulkActivateUserModal)"
      @close="closeModal($options.showBulkActivateUserModal)"
    />
    <SuspendUserModal
      v-else-if="value.showSuspendModal"
      :showModal="value.showSuspendModal"
      @close="closeModal($options.showSuspendModal)"
      @save="suspendUsers"
    />
  </div>
</template>

<script>
import BulkActivateUserModal from 'client/systemusers/Modals/BulkActivateUserModal.vue';
import SuspendUserModal from 'client/systemusers/Modals/SuspendUserModal.vue';

/**
 * @todo This component was added to fix a problem where the show modal properties were somehow
 * not reactive for some users locally - which caused the modals not to display even when the
 * show modal property was true. Since this was an impediment to testing (doh!), moving these
 * modals to their own component seems to fix the issue. :shrug: This issue was not seen in prod!
 *
 * Since this is a bit brute-force, it might be good to fine tune this logic - from the review:
 * `If it's a managed component do we want to handle this internal to the
 * component and instead accept an action that determines what's happening?`
 */
export default {
  name: 'ManageSystemUserState',

  components: {
    BulkActivateUserModal,
    SuspendUserModal,
  },

  props: {
    value: {
      type: Object,
      default: undefined,
    },
  },

  showBulkActivateUserModal: 'showBulkActivateUserModal',
  showSuspendModal: 'showSuspendModal',

  methods: {
    closeModal(modalType) {
      this.$emit('close', modalType);
    },

    suspendUsers() {
      this.$emit('save');
    },
  },
};
</script>
